import {useParams} from "react-router";
import {css, cx} from "@panda/css";

import {useUserDevice} from "@pg-mono/user-device";

import {useGetOfferDetailListQuery} from "../../../../offer/api/get_offer_detail_list";
import {useGetRegionDetailListBySlugQuery} from "../../../../region/api/get_region_detail_list_by_slug";
import {offerRedirectTracking} from "../../../tracking/offer_redirect_tracking";
import {IRankingItem} from "../../../types/IRankingItem";
import {IRankingListingViewParams} from "../../../types/IRankingListingViewParams";
import {getRankingItems} from "../../../utils/get_ranking_items";
import {OfferRankingCard} from "./OfferRankingCard";
import {OfferRankingListItem} from "./OfferRankingListItem";

const AFTER_PODIUM_OFFERS_MAX_SIZE = 2;

export function OfferRankingList() {
    const userDevice = useUserDevice();
    const {citySlug} = useParams<IRankingListingViewParams>();
    const {data} = useGetRegionDetailListBySlugQuery({slug: citySlug});
    const currentRegion = data?.results[0];
    const rankingItems = currentRegion ? getRankingItems(currentRegion.id) : null;
    const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
    const {data: rankingOffers} = useGetOfferDetailListQuery({offerIds});

    const podiumItems = rankingItems ? getPodiumItems(rankingItems, Boolean(userDevice.isMobile)) : null;

    const hasAfterPodiumItems = rankingItems ? rankingItems.length > 3 : null;
    const afterPodiumItems = rankingItems ? rankingItems.slice(3, 3 + AFTER_PODIUM_OFFERS_MAX_SIZE) : null;

    return (
        <div>
            {currentRegion && rankingOffers && (
                <div className={offerLists}>
                    {podiumItems && (
                        <ul className={cx(rankingListUl, podiumListGrid)}>
                            {podiumItems.map((item) => {
                                const podiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!podiumOffer) {
                                    return null;
                                }

                                const onOfferTracking = () => {
                                    offerRedirectTracking({
                                        city: currentRegion.name,
                                        position: item.regionOrder,
                                        vendor: podiumOffer.vendor.name,
                                        offerName: podiumOffer.name
                                    });
                                };

                                return (
                                    <OfferRankingCard
                                        key={`rolip_${item.offerId}`}
                                        place={item.regionOrder}
                                        offer={podiumOffer}
                                        onCardClick={onOfferTracking}
                                    />
                                );
                            })}
                        </ul>
                    )}
                    {hasAfterPodiumItems && afterPodiumItems && (
                        <ul className={rankingListUl}>
                            {afterPodiumItems.map((item) => {
                                const afterPodiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!afterPodiumOffer) {
                                    return null;
                                }
                                const onOfferTracking = () => {
                                    offerRedirectTracking({
                                        city: currentRegion.name,
                                        position: item.regionOrder,
                                        vendor: afterPodiumOffer.vendor.name,
                                        offerName: afterPodiumOffer.name
                                    });
                                };
                                return <OfferRankingListItem key={`roliap_${item.offerId}`} offer={afterPodiumOffer} onItemClick={onOfferTracking} />;
                            })}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
}

function getPodiumItems(sortedItems: IRankingItem[], isMobile: boolean) {
    if (isMobile) {
        return sortedItems.slice(0, 3);
    }

    return [sortedItems[1], sortedItems[0], sortedItems[2]];
}

const offerLists = css({
    display: "flex",
    flexDirection: "column",
    gap: 3.5,

    md: {
        gap: 8.5
    }
});

const rankingListUl = css({
    paddingLeft: 0,
    listStyle: "none",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    alignItems: "center",
    justifyContent: "center"
});

const podiumListGrid = css({
    "@media screen and (min-width: 1192px)": {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gridTemplateRows: "4rem 1fr minmax(4rem, max-content)"
    }
});
import {useParams} from "react-router";
import {css, cx} from "@panda/css";

import {useUserDevice} from "@pg-mono/user-device";

import {useGetOfferDetailListQuery} from "../../../../offer/api/get_offer_detail_list";
import {useGetRegionDetailListBySlugQuery} from "../../../../region/api/get_region_detail_list_by_slug";
import {offerRedirectTracking} from "../../../tracking/offer_redirect_tracking";
import {IRankingItem} from "../../../types/IRankingItem";
import {IRankingListingViewParams} from "../../../types/IRankingListingViewParams";
import {getRankingItems} from "../../../utils/get_ranking_items";
import {OfferRankingCard} from "./OfferRankingCard";
import {OfferRankingListItem} from "./OfferRankingListItem";

const AFTER_PODIUM_OFFERS_MAX_SIZE = 2;

export function OfferRankingList() {
    const userDevice = useUserDevice();
    const {citySlug} = useParams<IRankingListingViewParams>();
    const {data} = useGetRegionDetailListBySlugQuery({slug: citySlug});
    const currentRegion = data?.results[0];
    const rankingItems = currentRegion ? getRankingItems(currentRegion.id) : null;
    const offerIds = rankingItems ? rankingItems.map((item) => item.offerId) : [];
    const {data: rankingOffers} = useGetOfferDetailListQuery({offerIds});

    const podiumItems = rankingItems ? getPodiumItems(rankingItems, Boolean(userDevice.isMobile)) : null;

    const hasAfterPodiumItems = rankingItems ? rankingItems.length > 3 : null;
    const afterPodiumItems = rankingItems ? rankingItems.slice(3, 3 + AFTER_PODIUM_OFFERS_MAX_SIZE) : null;

    return (
        <div>
            {currentRegion && rankingOffers && (
                <div className={offerLists}>
                    {podiumItems && (
                        <ul className={cx(rankingListUl, podiumListGrid)}>
                            {podiumItems.map((item) => {
                                const podiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!podiumOffer) {
                                    return null;
                                }

                                const onOfferTracking = () => {
                                    offerRedirectTracking({
                                        city: currentRegion.name,
                                        position: item.regionOrder,
                                        vendor: podiumOffer.vendor.name,
                                        offerName: podiumOffer.name
                                    });
                                };

                                return (
                                    <OfferRankingCard
                                        key={`rolip_${item.offerId}`}
                                        place={item.regionOrder}
                                        offer={podiumOffer}
                                        onCardClick={onOfferTracking}
                                    />
                                );
                            })}
                        </ul>
                    )}
                    {hasAfterPodiumItems && afterPodiumItems && (
                        <ul className={rankingListUl}>
                            {afterPodiumItems.map((item) => {
                                const afterPodiumOffer = rankingOffers.find((offer) => offer.id === item.offerId);

                                if (!afterPodiumOffer) {
                                    return null;
                                }
                                const onOfferTracking = () => {
                                    offerRedirectTracking({
                                        city: currentRegion.name,
                                        position: item.regionOrder,
                                        vendor: afterPodiumOffer.vendor.name,
                                        offerName: afterPodiumOffer.name
                                    });
                                };
                                return <OfferRankingListItem key={`roliap_${item.offerId}`} offer={afterPodiumOffer} onItemClick={onOfferTracking} />;
                            })}
                        </ul>
                    )}
                </div>
            )}
        </div>
    );
}

function getPodiumItems(sortedItems: IRankingItem[], isMobile: boolean) {
    if (isMobile) {
        return sortedItems.slice(0, 3);
    }

    return [sortedItems[1], sortedItems[0], sortedItems[2]];
}

const offerLists = css({
    display: "flex",
    flexDirection: "column",
    gap: 3.5,

    md: {
        gap: 8.5
    }
});

const rankingListUl = css({
    paddingLeft: 0,
    listStyle: "none",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    gap: 3,
    alignItems: "center",
    justifyContent: "center"
});

const podiumListGrid = css({
    "@media screen and (min-width: 1192px)": {
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gridTemplateRows: "4rem 1fr minmax(4rem, max-content)"
    }
});
